import Vue from 'vue'
import store from '@/store/store'
import IdleVue from 'idle-vue'

const eventsHub = new Vue()

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 60000 * 14,
    startAtIdle: false,
})

export default new Vue({
    onIdle () {
        console.log('Session went idle')
    },
    onActive () {
        console.log('Session went active')
    },
})
